module.exports = __webpack_public_path__ + "static/img/pic_csjj_kcpx@2x.bc41dcb2.png";